import { render, staticRenderFns } from "./OrderParts.vue?vue&type=template&id=b625e6fe&scoped=true"
import script from "./OrderParts.vue?vue&type=script&lang=js"
export * from "./OrderParts.vue?vue&type=script&lang=js"
import style0 from "./OrderParts.vue?vue&type=style&index=0&id=b625e6fe&prod&lang=css"
import style1 from "./OrderParts.vue?vue&type=style&index=1&id=b625e6fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b625e6fe",
  null
  
)

export default component.exports